import React, { Component} from 'react';
import IconButton from 'material-ui/IconButton';
import Menu, { MenuItem } from 'material-ui/Menu';
import MoreVertIcon from 'material-ui-icons/MoreVert';
import { Link } from 'react-router';

class ClientUrl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null
    }
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const {
      id,
      name,
      slug,
      webinar_ids,
    } = this.props.clientUrl;
    const ITEM_HEIGHT = 48;
    const is_checked = _.includes(this.props.client_urls_ids, id);
    const { anchorEl } = this.state;

    return (
      <tr>
        <td>
          <p>
            <input
              type="checkbox"
              className="filled-in"
              id="filled-in-box10"
              key={id}
              checked={is_checked}
            />
            <label
              htmlFor="filled-in-box10"
              onClick={() => this.props.checkedClientUrlIds(id)}
            />
          </p>
        </td>
        <td>{name}</td>
        <td>{slug}</td>
        <td>{webinar_ids.length}</td>
        <td>
          <IconButton
            className="table_more"
            aria-label="More"
            aria-owns={anchorEl ? 'long-menu' : null}
            aria-haspopup="true"
            onClick={this.handleClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: 200,
              },
            }}
          >
            <Link to={`/client-url/${id}/edit`}>
              <MenuItem >Edit</MenuItem>
            </Link>
          </Menu>
        </td>
      </tr>

    );
  }
}

ClientUrl.defaultProps = {};

ClientUrl.propTypes = {};

export default ClientUrl;



// WEBPACK FOOTER //
// ./src/components/Admin/ClientUrls/List/ClientUrl.jsx